import React from 'react'
import { Descriptions } from 'antd'
import { capitalize, snakeCaseToTitle } from '../../util'
import { INewExpense } from '../../typings/entities/expense'

interface Props extends INewExpense {}
const bold: React.CSSProperties = { fontWeight: 'bold' }
const ExpenseDetail: React.FC<Props> = ({
	type,
	destinationType,
	destinationNature,
	destinationName,
	destinationID,
	amount,
	province,
	parentEntity,
	note,
	timestamps: { createdAt },
}) => (
	<Descriptions
		layout='vertical'
		bordered
		style={{ marginRight: '2rem' }}
		column={3}
	>
		<Descriptions.Item label='Entidad'>
			{snakeCaseToTitle(parentEntity?.name || '')}
		</Descriptions.Item>
		<Descriptions.Item label='Monto'>
			<span style={{ color: '#1890ff', fontWeight: 'bold' }}>${amount}</span>
		</Descriptions.Item>
		<Descriptions.Item label='Tipo'>{capitalize(type)}</Descriptions.Item>
		<Descriptions.Item label='Categoría de Justificación'>
			{snakeCaseToTitle(destinationType)}
		</Descriptions.Item>
		<Descriptions.Item label='Destino'>
			<p>
				<span style={bold}>Nombre: </span> {destinationName}
			</p>
			<p>
				<span style={bold}>Naturaleza: </span> {capitalize(destinationNature)}
			</p>
			<p>
				<span style={bold}>Identificación: </span> {capitalize(destinationID)}
			</p>
		</Descriptions.Item>
		{province && (
			<Descriptions.Item label='Provincia'>
				{snakeCaseToTitle(province)}
			</Descriptions.Item>
		)}
		<Descriptions.Item label='Fecha'>
			{new Date(createdAt).toLocaleDateString()}
		</Descriptions.Item>
		<Descriptions.Item label='Notas'>{note}</Descriptions.Item>
	</Descriptions>
)

export default ExpenseDetail
